import { Backdrop, CircularProgress } from '@mui/material';

type LoadingBackdropProps = {
  open: boolean;
  zIndex?: number;
};

/** Full-screen dimmed overlay with a centered spinner. */
export function LoadingBackdrop({ open, zIndex = 999 }: LoadingBackdropProps) {
  if (!open) {
    return null;
  }
  return (
    <Backdrop open={open} sx={{ zIndex }}>
      <CircularProgress />
    </Backdrop>
  );
}
